import React, { useState } from 'react';
import './PortfolioPage.css';

const PortfolioPage = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [expandedProject, setExpandedProject] = useState(null);

  const portfolioData = [
    {
      id: 1,
      title: "Supply & Installation of Safety Helmets for XYZ Construction",
      client: "XYZ Construction Ltd.",
      date: "March 2025",
      tags: ["Safety Equipment", "Commercial"],
      description: "Supplied 500 units of certified safety helmets with custom company branding. Provided on-site fitting assistance and safety training for all workers. Completed installation within 2 days across 3 construction sites in Lagos.",
      images: ["helmet-installation.jpg", "safety-training.jpg"],
      testimonial: "UB Resources delivered exactly what we needed on time. Their safety experts helped train our team properly - we've seen a 40% reduction in head injuries since implementation."
    },
    {
      id: 2,
      title: "Bulk Delivery of Carpentry Tools – Housing Estate Project",
      client: "Private Residential Project",
      date: "February 2025",
      tags: ["Carpentry", "Residential"],
      description: "Delivered complete carpentry toolkit for construction of 20 luxury housing units. Package included power tools, treated timber, nails, and accessories. Managed just-in-time deliveries to match construction phases.",
      images: ["carpentry-tools.jpg", "housing-project.jpg"],
      testimonial: null
    },
    {
      id: 3,
      title: "General Site Supplies for Government Building Project",
      client: "Federal Ministry of Works",
      date: "January 2025",
      tags: ["General Supply", "Public Sector"],
      description: "Provided ongoing supply of construction materials including cement, reinforcement bars, and electrical fittings for 6-month government building project. Implemented inventory management system to prevent shortages.",
      images: ["construction-site.jpg", "material-delivery.jpg"],
      testimonial: "Reliable weekly deliveries kept our project on schedule. UB Resources' tracking system gave us complete visibility of our material pipeline."
    },
    {
      id: 4,
      title: "Emergency PPE Supply for Oil & Gas Facility",
      client: "Major Oil & Gas Client",
      date: "December 2024",
      tags: ["Safety Equipment", "Commercial"],
      description: "Responded to urgent request for full PPE kits within 24 hours. Supplied flame-resistant coveralls, safety goggles, gloves, and specialized footwear for 150 workers.",
      images: ["ppe-kits.jpg", "oil-gas-site.jpg"],
      testimonial: "When we had an unexpected safety audit, UB Resources saved us from shutdown with their rapid response."
    },
    {
      id: 5,
      title: "School Furniture Supply Project",
      client: "State Education Board",
      date: "November 2024",
      tags: ["Furniture", "Public Sector"],
      description: "Manufactured and delivered 2,500 student desks and chairs to 15 public schools across the state. Included installation and after-sales support.",
      images: ["school-desks.jpg", "classroom-installation.jpg"],
      testimonial: "The durable furniture has held up perfectly through heavy student use. We're planning to expand the program next year."
    }
  ];

  const allTags = ['All', ...new Set(portfolioData.flatMap(project => project.tags))];

  const filteredProjects = activeFilter === 'All' 
    ? portfolioData 
    : portfolioData.filter(project => project.tags.includes(activeFilter));

  const toggleProjectExpand = (id) => {
    setExpandedProject(expandedProject === id ? null : id);
  };

  return (
    <div className="portfolio-page">
      <header className="portfolio-header">
        <h1>Our Completed Projects</h1>
        <p>Quality supplies and installations delivered to satisfied clients</p>
      </header>

      <div className="portfolio-controls">
        <div className="filter-tabs">
          {allTags.map(tag => (
            <button
              key={tag}
              className={`filter-tab ${activeFilter === tag ? 'active' : ''}`}
              onClick={() => setActiveFilter(tag)}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="search-container">
          <input type="text" placeholder="Search projects..." />
          <button className="search-button">Search</button>
        </div>
      </div>

      <div className="portfolio-grid">
        {filteredProjects.map(project => (
          <div 
            key={project.id} 
            className={`project-card ${expandedProject === project.id ? 'expanded' : ''}`}
          >
            <div className="project-card-header">
              <h3>{project.title}</h3>
              <button 
                className="expand-button"
                onClick={() => toggleProjectExpand(project.id)}
              >
                {expandedProject === project.id ? '−' : '+'}
              </button>
            </div>

            <div className="project-meta">
              <span className="client">{project.client}</span>
              <span className="date">{project.date}</span>
              <div className="tags">
                {project.tags.map(tag => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
            </div>

            <div className="project-content">
              <p className="description">{project.description}</p>

              {project.images && (
                <div className="project-gallery">
                  {project.images.map((image, index) => (
                    <div key={index} className="gallery-item">
                      <img 
                        src={`/images/portfolio/${image}`} 
                        alt={`Project ${project.id} - ${index + 1}`} 
                      />
                    </div>
                  ))}
                </div>
              )}

              {project.testimonial && (
                <div className="testimonial">
                  <div className="quote-icon">"</div>
                  <blockquote>{project.testimonial}</blockquote>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="portfolio-cta">
        <h2>Ready to Start Your Project?</h2>
        <p>Contact us today to discuss your supply and installation needs</p>
        <div className="cta-buttons">
          <a href="/contact" className="cta-button primary">Get a Quote</a>
          <a href="tel:+2347031901705" className="cta-button secondary">Call Now</a>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;